import React, {useEffect, useState} from 'react'
import { Box, Button, Stack, TextField, Typography} from '@mui/material'

import {exerciseOptions, fetchData} from '../utils/fetchData'

import HorizontalScrollbar from './HorizontalScrollBar'

function SearchExercises({setExercises, bodyPart, setBodyPart }) {

const [search, setSearch] = useState('')
const [bodyParts, setBodyParts] = useState([])
// const [exercises, setExercises] = useState([])


//can be used to generate or hold data that the intial load of the web application. 
useEffect (() => {
    const fetchExercisesData = async () => {
        const bodyPartsData = await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList', exerciseOptions);
        console.log(bodyPartsData)
        setBodyParts(['all', ...bodyPartsData]);
    }
    fetchExercisesData();
}, [])

const handleSearch = async () => {
    if(search){
        //takes in the path to the content selected and exercise options brings back the json object
         const exerciseData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions)

         const searchedExercises = exerciseData.filter(
            (exercise) => exercise.name.toLowerCase().includes(search) ||
            exercise.target.toLowerCase().includes(search) ||
            exercise.equipment.toLowerCase().includes(search) ||
            exercise.bodyPart.toLowerCase().includes(search) 
         )
         console.log(searchedExercises)

         setSearch('')
         setExercises(searchedExercises)
    }
}

  return (
    <Stack alignItems="center" mt="37px" justifyContent="center" p="20px">
    <Typography fontWeight={700} sx={{ fontSize: { lg: '44px', xs: '30px' } }} mb="49px" textAlign="center">
      Awesome Exercises You <br /> Should Know
    </Typography>
    <Box position="relative" mb="72px">
      <TextField
        height="76px"
        sx={{ input: { fontWeight: '700', border: 'none', borderRadius: '4px' }, width: { lg: '1170px', xs: '350px' }, backgroundColor: '#fff', borderRadius: '40px' }}
        value={search}
        onChange={(e) => setSearch(e.target.value.toLowerCase())}
        placeholder="Search Exercises"
        type="text"
      />
      <Button className="search-btn" sx={{ bgcolor: '#69A88E', color: '#fff', textTransform: 'none', width: { lg: '173px', xs: '80px' }, height: '56px', position: 'absolute', right: '0px', fontSize: { lg: '20px', xs: '14px' } }} onClick={handleSearch}>
        Search
      </Button>
    </Box>
    <Box sx={{ position: 'relative', width: '100%', p: '20px' }}>
      <HorizontalScrollbar data={bodyParts} setBodyPart={setBodyPart} bodyPart={bodyPart} isBodyParts /> 
    </Box>
  
  </Stack>
  )
}

export default SearchExercises